const LANGUAGES_RTL = ['ar'];

export const localeIsRightToLeft = (activeLocale: string): boolean => {
    return !!LANGUAGES_RTL.find((lang) => activeLocale.toLowerCase().split(/-|_/g)[0] === lang);
};
